export default __webpack_public_path__ + "static/media/information-white.8b60d409.svg";